import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss'],
})
export class ErrorsComponent {
  @Input() defaultMessage: string;
  @Input() error: any;

  public traceReference: string = '';
  public errorMessage: string;
  public errorMessageReason: string = '';
  public isHubtigerError: boolean = false;

  constructor(
    public modal: NgbActiveModal,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    //  //--For debug:
    //  console.log('Error received:')
    //  console.log(this.error);

    this.processError(this.error);
  }

  processError(error) {
    if (error && error.error && typeof error.error === 'string') {
      // Note: our error responses will always be an object and not string.
      // Uncomment this for when its needed:
      // // Check if the string can be parsed as JSON
      // try {
      //   const parsedError = JSON.parse(error.error);
      //   // If successful, parsedError is a JSON object
      //   console.log('JSON Error:', parsedError);
      //   return parsedError;
      // } catch (e) {
      //   // If parsing fails, it's plain text
      //   console.log('Plain text error:', error.error);
      //   return error.error;
      // }

      this.errorMessage = this.defaultMessage;
      this.errorMessageReason = error.error;
    } else if (error && error.error && typeof error.error === 'object') {
      // Check if the object has the traceReference property
      if (error.error.traceReference) {
        // Our error object
        this.traceReference = error.error.traceReference || null;
        if (error.error.message) {
          this.errorMessage = error.error.message || this.defaultMessage;
        } else {
          this.errorMessage = this.defaultMessage;
        }
        this.isHubtigerError = true;
      } else {
        // Another type of error object
        this.errorMessage = this.defaultMessage;
        this.errorMessageReason = JSON.stringify(error.error);
      }
    } else {
      // The error property is not a string or object (unexpected type)
      this.errorMessage = this.defaultMessage;
      if (error && error.error) {
        this.errorMessageReason = error.error;
      }
    }
  }

  copyClipboard() {
    navigator.clipboard.writeText(this.traceReference).then(() => {
      this.messageService.add({
        severity: 'Success',
        summary: 'Copied to clipboard',
        life: 3000, // Toast will disappear after 3 seconds
      });
    });
  }
}
